import { BiometricsInitiationBottomSheet as UIBiometricsInitiationBottomSheet, type BiometricsInitiationBottomSheetProps } from '@jagad/ui'
import { safeAreaInset } from '@lib/telegram'
import { useTranslation } from 'react-i18next'

type Props = Omit<
  BiometricsInitiationBottomSheetProps,
  'title' | 'titleAvailable' | 'description' | 'enableButtonLabel' | 'skipButtonLabel' | 'safeAreaBottom'
>

const BiometricsInitiationBottomSheet = (props: Props) => {
  const { t } = useTranslation()
  return (
    <UIBiometricsInitiationBottomSheet
      {...props}
      title={t('authentication.biometrics.title')}
      titleAvailable={t('authentication.biometrics.available')}
      description={t('authentication.biometrics.description')}
      enableButtonLabel={t('authentication.biometrics.enableButton')}
      skipButtonLabel={t('authentication.biometrics.skipButton')}
      safeAreaBottom={safeAreaInset().bottom}
    />
  )
}

export default BiometricsInitiationBottomSheet
